import * as d3 from 'd3';
import * as ReactFauxDOM from 'react-faux-dom';

export function SparklineChart({
  width,
  height,
  margin,
  data,
  className,
}: {
  width: number;
  height: number;
  margin: number;
  data: number[];
  className?: string;
}) {
  const el = d3
    .select(ReactFauxDOM.createElement('svg'))
    .attr('width', width)
    .attr('height', height)
    .attr('className', className ?? '');

  const x = d3
    .scaleLinear()
    .range([0, width - margin * 2])
    .domain(d3.extent(data, (_d, i) => i) as [number, number]);

  const y = d3
    .scaleLinear()
    .range([height - margin * 2, 0])
    .interpolate(d3.interpolateRound)
    .domain(d3.extent(data, (d) => d) as [number, number]);

  const line = d3
    .line<number>()
    .x((_d, i) => x(i))
    .y((d) => y(d));

  el.append('path')
    .datum(data)
    .attr('key', 'sparkline')
    .attr('d', line)
    .attr('transform', `translate(${margin}, ${margin})`);

  return el.node()?.toReact() ?? null;
}
